import {CSSProperties, FC} from 'react';


export interface IIconCarryingNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarryingNissan: FC<IIconCarryingNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M17.893 8.48a1.186 1.186 0 0 0-1.18-1.073h-2.429c.214-.378.337-.815.337-1.28 0-1.438-1.17-2.609-2.61-2.609a2.612 2.612 0 0 0-2.609 2.61c0 .464.123.9.337 1.28h-2.53c-.617 0-1.125.472-1.18 1.075L3 19.206v.091c0 .653.531 1.185 1.184 1.185h15.631c.654 0 1.185-.532 1.185-1.185v-.093L17.893 8.48ZM12.01 4.834c.713 0 1.294.58 1.294 1.293 0 .65-.483 1.19-1.108 1.28h-.371a1.295 1.295 0 0 1-1.108-1.28c0-.712.58-1.293 1.293-1.293ZM4.38 19.166l2.95-10.443h4.416a2.638 2.638 0 0 0 .533 0h4.315l3.026 10.443H4.379Z" />
            <path d="m11.956 16.157-1.637-2.492 1.344-1.682a.29.29 0 0 0 .06-.188c0-.247-.315-.503-.563-.503a.31.31 0 0 0-.27.143l-1.622 2.207v-2.05c0-.21-.248-.3-.488-.3-.248 0-.488.09-.488.3v4.88c0 .203.24.308.488.308.24 0 .488-.105.488-.308v-1.471l.405-.51 1.412 2.139a.38.38 0 0 0 .338.188c.285 0 .585-.248.585-.488 0-.06-.015-.12-.052-.173ZM15.484 13.898h-1.276c-.195 0-.3.195-.3.382 0 .196.105.383.3.383h.608v.443c0 .586-.3.864-.788.864-.496 0-.78-.278-.78-.864v-2.094c-.001-.586.284-.864.787-.864.638 0 .759.39.781.743.008.233.225.308.488.308.323 0 .488-.09.488-.465 0-.901-.758-1.442-1.794-1.442-.954 0-1.727.466-1.727 1.72v2.094c0 1.254.766 1.72 1.757 1.72.99 0 1.764-.466 1.764-1.72v-.893c0-.165-.112-.315-.308-.315Z" />
        </svg>
    );
};
